import { render, staticRenderFns } from "./index.vue?vue&type=template&id=27961eac&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=27961eac&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27961eac",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_manage_sbGx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('27961eac')) {
      api.createRecord('27961eac', component.options)
    } else {
      api.reload('27961eac', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=27961eac&scoped=true", function () {
      api.rerender('27961eac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/system/addRole/index.vue"
export default component.exports